import { Link } from "react-router-dom";
import type { Anime } from "@/mocks/anime";
import { formatUpdated } from "@/utils/anime";

export default function AnimeCardRow({ items }: { items: Anime[] }) {
  if (!items.length) {
    return <p className="mt-3 text-[12px] text-foreground-500">暂无更新记录。</p>;
  }
  return (
    <ul className="mt-3 divide-y divide-background-200">
      {items.map((anime) => (
        <li key={anime.id}>
          <Link to={`/detail/${anime.id}`} className="flex items-center gap-2.5 py-2.5 group cursor-pointer">
            <span className="w-8 h-11 shrink-0 rounded overflow-hidden bg-background-200 block">
              <img
                src={anime.cover}
                alt={`${anime.title} 封面`}
                title={`${anime.title} - 高清动漫在线观看`}
                className="w-full h-full object-cover"
              />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-[12.5px] text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                {anime.title}
              </span>
              <span className="block mt-0.5 text-[11px] text-foreground-500">
                更新至 {anime.episodes} 集 · {formatUpdated(anime.updatedAt)}
              </span>
            </span>
            <span className="shrink-0 text-[10px] px-1.5 py-0.5 rounded-full bg-accent-100 text-accent-900 whitespace-nowrap">
              {anime.status === "连载中" ? "新集" : "完结"}
            </span>
          </Link>
        </li>
      ))}
    </ul>
  );
}